exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#bouteille .mainbouteille #levelbouteille>span#indicators .level[data-v-b88e3ae8]{position:absolute;top:-35px;height:10px;display:block;width:auto;margin-top:10px;border-radius:5px}.histo[data-v-b88e3ae8]{border-left:4px solid #fff}.histo.regul[data-v-b88e3ae8]{border-left-color:#f58e28}#codebouteille[data-v-b88e3ae8]{font-size:min(3.5vw,1.8rem)}.favori[data-v-b88e3ae8]{display:inline-flex;align-items:center;gap:.6em;background:#f1c40f;color:#222;font-weight:600;font-size:clamp(13px,3.5vw,15px);line-height:1;white-space:nowrap;padding:.7em 1.1em;border-radius:8px;cursor:pointer;box-shadow:0 2px 4px rgba(0,0,0,.15);transition:background-color .3s;max-width:100%;text-align:center;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b88e3ae8","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/bouteille/Bouteille.vue
// module id = 656
// module chunks = 0